import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ChatHelperService } from 'src/app/services/helpers/chat-helper.service';
import { ChatHttpService } from 'src/app/services/http-services/chat/chat-http.service';

@Component({
  selector: 'app-delete-chat-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './delete-chat-modal.component.html',
})
export class DeleteChatModalComponent {
  @Input() conversationId!: number;
  @Input() leaveOrDelete = 'delete';
  @Input() deleteChatText: any;
  @Output() closeDeleteChatModal = new EventEmitter<boolean>();
  @Output() deleteChat = new EventEmitter<boolean>(false);

  constructor(
    private chatsHttpService: ChatHttpService,
    private chatHelperService: ChatHelperService,
    private toastService: ToastrService
  ) { }

  takeAction() {
    this.leaveOrDelete === 'delete' ? this.delete() : this.leaveGroup();
  }

  delete() {
    this.chatsHttpService.archiveConversationV2(this.conversationId).subscribe(res => {
      this.closeDeleteChatModal.emit(true);
      this.deleteChat.emit(true);
      this.chatHelperService.refreshListOfConversations(true);
    });
  }

  leaveGroup() {
    this.chatsHttpService.leaveConversationV2(this.conversationId).subscribe(res => {
      this.closeDeleteChatModal.emit(true);
      this.deleteChat.emit(true);
      this.toastService.success(res.message);
      this.chatHelperService.refreshListOfConversations(true);
    });
  }

}
